import _ from 'lodash'
import Backbone from 'backbone'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Give the names of ID and tempId attributes, will return a function that
 * can be used on an array or Backbone.Collection to find by id or tempId.
 * See findByBreakdownRangeIds() in chart-designer-serie.js for an exmaple
 */
function findByIdsFactory ({ idAttr, tempIdAttr } = {}) {
	idAttr = idAttr || 'id'
	tempIdAttr = tempIdAttr || 'tempId'

	return function ({ id, tempId, collection }) {
		let array = collection instanceof Backbone.Collection
			? collection.toArray() : collection

		let attrToUse, idToUse
		if (!_.isNil(id)) {
			attrToUse = idAttr
			idToUse = id
		} else if (!_.isNil(tempId)) {
			attrToUse = tempIdAttr
			idToUse = tempId
		} else {
			// Neither an id or tempId was provided, so don't return any results
			return null
		}

		return _.find(array, p => {
			let obj = unwrapModel(p)
			return obj && obj[attrToUse] === idToUse
		})
	}
}

/**
 * Similar to findByIdsFactory, but returns a function that will just return
 * true if the id/tempId matches a given object (instead of finding one in
 * a list of objects)
 */
function matchesFactory ({ idAttr, tempIdAttr } = {}) {
	let find = findByIdsFactory({ idAttr, tempIdAttr })
	return function ({ id, tempId, object }) {
		return !!find({ id, tempId, collection: [ object ] })
	}
}

_.extend(findByIdsFactory, { matchesFactory })
export default findByIdsFactory
export { matchesFactory }

findByIdsFactory.__filename__ = 'charts/model/find-by-ids-factory.js'
